<template>
  <transition name="loader-fade">
    <div v-if="visible" class="loader-overlay">
      <div class="loader-content">
        <div class="loader-spinner"></div>
        <p class="loader-text">{{ message }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Loader',
  data() {
    return {
      visible: false,
      message: 'Loading...'
    };
  },
  created() {
    // Expose methods globally so any component can call them
    window.showLoading = (msg = 'Loading...') => {
      this.visible = true;
      this.message = msg;
    };

    window.hideLoading = () => {
      this.visible = false;
    };
  }
};
</script>

<style lang="scss" scoped>
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.loader-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e0e0e0;
  border-top-color: #3288D2;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.loader-text {
  margin: 0;
  color: #666;
  font-size: 14px;
  font-weight: 500;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loader-fade-enter-active,
.loader-fade-leave-active {
  transition: opacity 0.2s ease;
}

.loader-fade-enter,
.loader-fade-leave-to {
  opacity: 0;
}
</style>
